import { Subject } from 'rxjs';
export const file$ = new Subject();
window.f5.onFileChange((path, stat) => file$.next({ path, stat }));
